module.exports = __webpack_public_path__ + "fonts/AznauriRoundRegular-3.a171c07a.ttf";